import Swiper from 'swiper';
import Navigation from 'swiper/modules/navigation.mjs';

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.swiper-element-viewed').forEach(swiper => {
    new Swiper(swiper, {
      modules: [ Navigation ],
      speed: 400,
      spaceBetween: 32,
      slidesPerView: 6,
      loopAdditionalSlides: 16,
      loop: false,
      freeMode: true,
      cssMode: true,
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        640: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
        1024: {
          spaceBetween: 32,
        },
        1200: {
          spaceBetween: 32,
        },
        1440: {
          spaceBetween: 32,
        },
        4096: {
          spaceBetween: 32,
        }
      },
      navigation: {
        enabled: true,
        nextEl: swiper.closest('.block-container').querySelector('.button-next'),
        prevEl: swiper.closest('.block-container').querySelector('.button-prev'),
      }
    });
  });
});
